import req from "../http";

const personalStatement = {
  // 取得 個資聲明歷史版本
  getPersonalStatementHistory(params) {
    return req("get", "/ResumeModule/personalstatement/history", params);
  },

  // 取得 個資聲明最新版本
  getLatestPersonalStatement(params) {
    return req("get", "/ResumeModule/personalstatement/newest", params);
  },

  // 取得 個資聲明
  getPersonalStatement(guid) {
    return req("get", `/ResumeModule/personalstatement/${guid}`);
  },

  // 新增 個資聲明
  postPersonalStatement(params) {
    return req("post", "/ResumeModule/personalstatement", params);
  },

  // 更新 個資聲明
  putPersonalStatement(params) {
    return req("put", "/ResumeModule/personalstatement", params);
  },
};

export default personalStatement;